<template>
  <div class="menu-container">
    <v-menu
      open-on-hover
    >
      <template v-slot:activator="{ props: activatorProps, isActive }">
        <v-btn
          v-bind="activatorProps"
          :data-testid="activatorTestId"
          :aria-expanded="isActive ? 'true' : 'false'"
          @click="(e: Event) => { activatorProps?.onClick?.(e); }"
        >
          <slot name="expander" :isActive="isActive"></slot>
          <span
            v-if="toggleTestId"
            class="menu-toggle-hook"
            :data-testid="toggleTestId"
            aria-hidden="true"
          />
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          class="sub-item"
          :data-testid="attachItemTestIds ? (item.dataTestId || itemTestIdFromPath(item.path)) : undefined"
          @click="handleListItemClick(item)"
        >
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps<{
  items: any[];
  activatorTestId?: string;
  toggleTestId?: string;
  /** Only set on desktop nav so Selenium does not hit hidden mobile duplicates. */
  attachItemTestIds?: boolean;
  /** Prefix for auto-generated item testids (e.g. desktop-href / nav-). */
  itemTestIdPrefix?: string;
}>();
function handleListItemClick(item: any) {
  if (item.path) router.push(item.path)
  else if (item.event) item.event.callback()
}
function itemTestIdFromPath(path?: string) {
  if (!path) return undefined;
  let slug = String(path).replace(/^\//, '').replace(/\//g, '-') || 'home';
  const prefix = props.itemTestIdPrefix || 'nav-';
  if (prefix === 'desktop-href' && slug === 'players') slug = 'player';
  return `${prefix}${slug}`;
}
</script>

<style lang="scss" scoped>
.menu-toggle-hook {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.menu-container :deep(.v-btn) {
  box-shadow: none;
  text-transform: none;
  background: none;
  margin: 0;
  padding: 0;
  min-width: 1em;
  position: relative;
  :hover {
    box-shadow: none;
  }
  .v-btn__content {
    color: #DAE4ED;
  }

  .v-btn__overlay {
    display: none;
  }

  .down-icon {
    margin-top: 0.3em;
    margin-left: 0.3em;
    opacity: 0.5;
  }
}


.sub-item {
  border-radius: 0.3em;
  margin: 0.3em;
  min-height: auto;
  cursor: pointer;
  :deep(.v-list-item-title) a {
    text-decoration: none;
    color: inherit;
  }
  
  &:hover {
    background-color: #191c3314;
  }
}

.active {
  background-color: #393e5d14;
  padding: 0.375rem;
  border-radius: 0.375rem;
}
</style>